import { useCallback, useEffect, useState } from 'react';
import {
  availabilityApi,
  type AvailabilityScopeRule,
  type TeacherAvailabilityOverride,
} from '@/lib/availability';

export function useTeacherAvailabilityRules(wpUserId: number | null, enabled = true) {
  const [groupRules, setGroupRules] = useState<AvailabilityScopeRule[]>([]);
  const [overrides, setOverrides] = useState<TeacherAvailabilityOverride[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!wpUserId || !enabled) {
      setGroupRules([]);
      setOverrides([]);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await availabilityApi.getTeacherRules(wpUserId);
      setGroupRules(data.groupRules ?? []);
      setOverrides(data.overrides ?? []);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Laden fehlgeschlagen');
      setGroupRules([]);
      setOverrides([]);
    } finally {
      setLoading(false);
    }
  }, [wpUserId, enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    groupRules,
    overrides,
    loading,
    error,
    reload,
    setGroupRules,
    setOverrides,
  };
}
